<template>
  <SignLog :form-name="'Sign in'" />
</template>

<script>
import SignLog from "@/components/form/SignLog";

export default {
  components: {
    SignLog,
  },
};
</script>

<style lang="scss" scoped></style>